const popup_catalog = {
    mobile: false,
    catalo_is_visible: false,
    catalog_nav_link_mobile: null,
    catalog_nav_link_pc: null,
    overlayer: null,
    catalog: null,
    init() {
        this.mobile = window.innerWidth <= 760

        this.catalog = document.getElementById('popup-catalog')
        this.overlayer = document.querySelector('.dark-overlayer')
        // this.catalog_nav_link_pc = document.getElementById('catalog_nav-link-pc')
        // this.catalog_nav_link_mobile = document.getElementById('catalog_nav-link-mobile')
        this._initEventListener()
    },
    _initEventListener() {
        // this.catalog_nav_link_pc.click.bind(this)
        // this.catalog_nav_link_pc.addEventListener('click', function (e){
        //     this.change_visibility_popup_catalog()
        //     e.preventDefault();
        // }, false)
        // this.catalog_nav_link_pc.addEventListener('click', () => this.change_visibility_popup_catalog(), false)
        // this.catalog_nav_link_mobile.addEventListener('click', (e) => {
        //     this.change_visibility_popup_catalog()
        //     e.preventDefault();
        // })
        this.overlayer.addEventListener('click', (e) => {
            this.change_visibility_popup_catalog()
            e.preventDefault();
        })
    },
    hide_popup_catalog() {
        if (!this.catalo_is_visible)
            return
        this.catalo_is_visible = true
        this.change_visibility_popup_catalog()
    },
    change_visibility_popup_catalog() {
        window.event.preventDefault()
        if (this.mobile) {
            this._change_visibility_popup_catalog_mobile()
        } else {
            this._change_visibility_popup_catalog_pc()
        }
        this.catalo_is_visible = !this.catalo_is_visible
    },
    _change_visibility_popup_catalog_pc() {
        this.catalog.classList.toggle('visible')
        if (this.catalog.classList.contains('visible')) {
            this.showOverlayer()
        } else {
            this.hideOverlayer()
        }
    },
    _change_visibility_popup_catalog_mobile() {
        this.catalog.style.transition = 'all 0.5s ease-out';
        if (this.catalo_is_visible) {
            this._show_popup_catalog_mobile()
        } else {
            this._hide_popup_catalog_mobile()
        }
    },
    _show_popup_catalog_mobile() {
        this.catalog.style.transform = 'translateX(0px)';
        document.body.style.overflow = '';
        this.hideOverlayer();
    },
    _hide_popup_catalog_mobile() {
        this.catalog.style.transform = 'translateX(320px)';
        document.body.style.overflow = 'hidden';
        this.showOverlayer();
    },
    showOverlayer() {
        this.overlayer.style.transform = 'translateX(0)';
        this.overlayer.style.opacity = '1';
    },
    hideOverlayer() {
        this.overlayer.style.opacity = '0';
        setTimeout(this.hidingShift(), 600);
    },
    hidingShift() {
        this.overlayer.style.transform = 'translateX(-100%)';
    }
}

const mobile_menu = {
    mmcounter: 0,
    mobMenuButtons: null,
    mobMenuWr: null,
    mobMenuBody: null,
    mobBack: null,
    mobNavItems: null,
    mobBodyScrollTop: null,
    init() {
        this.mobMenuButtons = document.querySelectorAll('.with-submenu .cat-in-popup-cat__expand-it');
        this.mobMenuWr = document.querySelector('.popup-catalog__wrap');
        this.mobMenuBody = document.querySelector('.popup-catalog__body');
        this.mobBack = document.querySelector('.popup-catalog__back-button');
        this.mobNavItems = document.querySelectorAll('.popup-catalog__nav-item.with-submenu');
        this._initEventListener()
    },
    _initEventListener() {
        for (let elem of this.mobMenuButtons) {
            elem.addEventListener('click', () => {
                if (this.mmcounter === 0) {
                    this.mobBodyScrollTop = this.mobMenuBody.scrollTop;
                }
                this.mmcounter++;
                this.mobMenuBody.scrollTop = 0;
                elem.parentElement.parentElement.classList.add('expanded');
                this.mobMenuWr.style.transform = 'translateX(-' + 100 * this.mmcounter + '%';
                this.mobBack.classList.add('visible');
            });
        }

        this.mobBack.addEventListener('click', () => {
            if (this.mmcounter === 1) {
                this.mobBack.classList.remove('visible');
                this.mobMenuBody.scrollTop = this.mobBodyScrollTop;
            }
            if (this.mmcounter > 0) {
                this.mmcounter--;
                this.mobMenuWr.style.transform = 'translateX(-' + 100 * this.mmcounter + '%';
            }
            if (this.mmcounter === 0) {
                for (let elem of this.mobNavItems) {
                    elem.classList.remove('expanded');
                }
            }
        })
    },

}

const general = {
    // главный контейнер для контента
    main: document.querySelector('main'),
    fadeIn(el) {

        var opacity = 0.01;
        document.querySelector(el).style.display = "block";
        var timer = setInterval(function () {
            if (opacity >= 1) {
                clearInterval(timer);
            }
            document.querySelector(el).style.opacity = opacity;
            opacity += opacity * 0.1;
        }, 10);
    }
}

const swipers = {
    product_card_thumbs: null,
    product_card_main: null,
    product_card_popup_main: null,
    product_card_popup_thumbs: null,
}

export default {
    popup_catalog,
    mobile_menu,
    swipers,
    general
}